import MonsterSpritesheet from "./MonsterSpritesheet";
import NamedSpriteSpritesheet from "./NamedSpriteSpritesheet";

export default class MonsterAnimationFrameSpritesheet extends NamedSpriteSpritesheet {
    /**
     * 
     * @param {string} fileName 
     * @param {number} spriteSize 
     * @param {MonsterSpritesheet} monsterSpritesheet 
     */
    constructor(fileName, spriteSize, monsterSpritesheet) {
        super(fileName, spriteSize);

        /**
         * @constant
         * @type {MonsterSpritesheet}
         */
        this.monsterSpritesheet = monsterSpritesheet;

        // Tell the superclass to start loading the image.
        this.loadImage();
    }

    /**
     * @inheritdoc
     * @override
     */
    populateSpriteMap() {

        /////////////////////////////////////
        // Mark the spritesheet as loaded.
        /////////////////////////////////////

        this.loaded = true;

        // Tell the parent that we are done loading.
        this.monsterSpritesheet.onSpritesheetLoaded();
    }

}
